import LeadProvider from './Lead.provider';

export default LeadProvider;
